import api from '../../base';
import { ORDERS_URL } from '../../orders';
import { dummyPdf } from '../../mocks/ordersMock';
import {
  PickupListDownloadRequest,
  PickupListsRequest,
  PickupListsResponse,
} from './pickupListTypes';
import { MOCK_PICKUP_LIST_CONTENT_DISPOSITION, mockPickupLists } from './pickupListMocks';

const BASE_PATH = `${ORDERS_URL}/pickup-lists`;

export async function getPickupLists(
  request: PickupListsRequest,
  signal?: AbortSignal,
): Promise<PickupListsResponse> {
  const response = await api.post<PickupListsResponse>(BASE_PATH, request, { signal });

  return response.data;
}

api.mock
  .onPost(BASE_PATH)
  .reply(200, mockPickupLists);

export async function downloadPickupList(
  request: PickupListDownloadRequest,
  signal?: AbortSignal,
) {
  return api.post<File>(
    `${BASE_PATH}/download`,
    request,
    {
      responseType: 'arraybuffer',
      signal,
    },
  );
}

api.mock
  .onPost(`${BASE_PATH}/download`)
  .reply(200, dummyPdf, { 'content-disposition': MOCK_PICKUP_LIST_CONTENT_DISPOSITION });
